import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { TranslateModule } from '@ngx-translate/core';
import { OrderLineItemValidationService } from './order-line-item-validation.service';
@Component({
  selector: 'orders-line-item-validation-banner',
  imports: [CommonModule, GalaxyAlertModule, TranslateModule],
  templateUrl: './order-line-item-validation-banner.component.html',
  styleUrl: './order-line-item-validation-banner.component.scss',
})
export class OrderLineItemValidationBannerComponent {
  protected formattedLineItemErrors$ = this.orderLineItemValidationService.formattedLineItemErrors$;
  constructor(private orderLineItemValidationService: OrderLineItemValidationService) {}
}
